import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
interface DesktopDonationCountListProps {
  isGuest: boolean;
}
export const DesktopDonationCountList = t0 => {
  const $ = _c(17);
  const {
    isGuest
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = AuthQueryOptions["get:/wello/v2/auth/home-donation/my"]();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = !isGuest;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      ...t1,
      select: _temp,
      enabled: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: donationInfo
  } = useQuery(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("mt-24 text-Gray-600 typo-h6", "mobile-tablet:hidden");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-600">일반기부</span>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = donationInfo?.generalDonationCount || 0;
  let t7;
  if ($[5] !== t6) {
    t7 = <li className="flex items-center justify-between border-b border-Gray-300 px-24 py-20">{t5}<span className="font-700">{t6}건</span></li>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-600">지정기부</span>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = donationInfo?.specificDonationCount || 0;
  let t10;
  if ($[8] !== t9) {
    t10 = <li className="flex items-center justify-between border-b border-Gray-300 px-24 py-20">{t8}<span className="font-700">{t9}건</span></li>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-600 text-B-500">총 기부 건수</span>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const t12 = donationInfo?.donationCount || 0;
  let t13;
  if ($[11] !== t12) {
    t13 = <li className="flex items-center justify-between border-b border-Gray-300 px-24 py-20">{t11}<span className="font-700 text-B-500">{t12}건</span></li>;
    $[11] = t12;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== t10 || $[14] !== t13 || $[15] !== t7) {
    t14 = <ul className={t4}>{t7}{t10}{t13}</ul>;
    $[13] = t10;
    $[14] = t13;
    $[15] = t7;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  return t14;
};
function _temp(data) {
  return {
    donationCount: data.context?.donationCount,
    generalDonationCount: data.context?.generalDonationCount,
    homeLoveGovCodeList: data.context?.homeLoveGovCodeList,
    specificDonationCount: data.context?.specificDonationCount,
    totalDonationAmount: data.context?.totalDonationAmount
  };
}